import { Lock } from 'lucide-react';
import type { JSX } from 'react';
import styles from './FeuilleDocument.module.css';

export interface FeuilleDocumentProps {
  /** Nom du fichier : son extension s'inscrit sur la feuille (PDF, JPG…). */
  nomFichier?: string;
  confidentiel?: boolean;
  /** `sm` dans les listes, `lg` en tête de fiche. */
  taille?: 'sm' | 'lg';
  archive?: boolean;
}

function extension(nom: string | undefined): string | null {
  if (!nom) return null;
  const point = nom.lastIndexOf('.');
  if (point < 0 || point === nom.length - 1) return null;
  return nom.slice(point + 1, point + 5).toUpperCase();
}

/**
 * Un document du coffre, dessiné comme une feuille au coin plié : son
 * extension en pied, un sceau quand il est confidentiel. Purement visuel —
 * le titre, le type et la confidentialité se lisent à côté, en texte.
 */
export function FeuilleDocument({
  nomFichier,
  confidentiel = false,
  taille = 'sm',
  archive = false,
}: FeuilleDocumentProps): JSX.Element {
  const ext = extension(nomFichier);
  return (
    <span
      className={styles.feuille}
      data-taille={taille}
      data-archive={archive ? 'oui' : undefined}
      aria-hidden="true"
    >
      <span className={styles.lignes} />
      {ext ? <span className={styles.extension}>{ext}</span> : null}
      {confidentiel ? (
        <span className={styles.sceau}>
          <Lock size={taille === 'lg' ? 14 : 10} strokeWidth={2} />
        </span>
      ) : null}
    </span>
  );
}
